import React, { useMemo, useState } from 'react';
import '../styles/Turmas.css';
import { alunos, turmas } from '../data/escolaData.js';

const views = [
  { id: 'nomes', label: 'Nomes' },
  { id: 'entrada', label: 'Data de entrada' },
  { id: 'nascimento', label: 'Data de nascimento' },
  { id: 'acessos', label: 'Acessos' }
];

const formatDate = (value) => {
  if (!value) return '';
  const [ano, mes, dia] = value.split('-');
  return `${dia}/${mes}/${ano}`;
};

const Turmas = () => {
  const [turmaSelecionada, setTurmaSelecionada] = useState('');
  const [viewSelecionada, setViewSelecionada] = useState('nomes');

  const alunosFiltrados = useMemo(() => {
    if (!turmaSelecionada) return alunos;
    return alunos.filter((aluno) => aluno.turmaId === turmaSelecionada);
  }, [turmaSelecionada]);

  const turmaNome = turmas.find((turma) => turma.id === turmaSelecionada)?.nome || 'Todas as turmas';

  return (
    <div className="turmas-page">
      <header className="turmas-header">
        <div>
          <h2>Turmas</h2>
          <p>Visualize os alunos com informações detalhadas e atalhos rápidos.</p>
        </div>
        <div className="turmas-select">
          <label htmlFor="turma">Selecionar turma</label>
          <select
            id="turma"
            value={turmaSelecionada}
            onChange={(event) => setTurmaSelecionada(event.target.value)}
          >
            <option value="">Todas</option>
            {turmas.map((turma) => (
              <option key={turma.id} value={turma.id}>
                {turma.nome}
              </option>
            ))}
          </select>
        </div>
      </header>

      <section className="turmas-views">
        <div className="view-tabs">
          {views.map((view) => (
            <button
              key={view.id}
              type="button"
              className={`view-tab ${viewSelecionada === view.id ? 'active' : ''}`}
              onClick={() => setViewSelecionada(view.id)}
            >
              {view.label}
            </button>
          ))}
        </div>
        <div className="view-summary">
          <h3>{turmaNome}</h3>
          <span>{alunosFiltrados.length} alunos</span>
        </div>
      </section>

      <section className="turmas-table">
        <table>
          <thead>
            <tr>
              <th>Aluno</th>
              {viewSelecionada === 'entrada' && <th>Data de entrada</th>}
              {viewSelecionada === 'nascimento' && <th>Data de nascimento</th>}
              {viewSelecionada === 'acessos' && (
                <>
                  <th>Frequência</th>
                  <th>Notas</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {alunosFiltrados.map((aluno) => (
              <tr key={aluno.id}>
                <td>
                  <div className="aluno-info">
                    <span className="aluno-nome">{aluno.nome}</span>
                    <small>Turma {turmas.find((turma) => turma.id === aluno.turmaId)?.nome}</small>
                  </div>
                </td>
                {viewSelecionada === 'entrada' && <td>{formatDate(aluno.dataEntrada)}</td>}
                {viewSelecionada === 'nascimento' && <td>{formatDate(aluno.dataNascimento)}</td>}
                {viewSelecionada === 'acessos' && (
                  <>
                    <td>
                      <button type="button" className="btn-link" onClick={() => alert('Acesso rápido para Frequência.')}
                      >
                        Ver frequência
                      </button>
                    </td>
                    <td>
                      <button type="button" className="btn-link" onClick={() => alert('Acesso rápido para Notas.')}
                      >
                        Ver notas
                      </button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default Turmas;
